import React from 'react';
import { ComponentLoaderMap } from '@/utils/types/ComponentLoaderMap';
// Single Templates
import { createContext, lazy, Suspense, useEffect, useState } from 'react';
import { ScrollRestoration } from 'react-router-dom';
import { lmGetPost } from '@/utils/api';
import Loading from '@/components/shared/Loading';
import { TemplateLoaderProps } from '@/utils/types/TemplateLoaderProps';
import { TemplateProps } from '@/utils/types/TemplateProps';
import { APIResult } from '@/utils/types/APIResult';
import { Post } from '@/utils/types/Post';
// const LMAnnouncement = lazy( () => import( '@/components/templates/single/LMAnnouncement' ) );
// const LMAnalystReport = lazy( () => import( '@/components/templates/single/LMAnalystReport' ) );
const LMBlog = lazy( () => import( '@/components/templates/single/LMBlog' ) );
// const LMCustomerStory = lazy( () => import( '@/components/templates/single/LMCustomerStory' ) );
// const LMEvent = lazy( () => import( '@/components/templates/single/LMEvent' ) );
const LMForm = lazy( () => import( '@/components/templates/single/LMForm' ) );
// const LMGlossary = lazy( () => import( '@/components/templates/single/LMGlossary' ) );
// const LMLegal = lazy( () => import( '@/components/templates/single/LMLegal' ) );
// const LMMediaCoverage = lazy( () => import( '@/components/templates/single/LMMediaCoverage' ) );
// const LMPodcast = lazy( () => import( '@/components/templates/single/LMPodcast' ) );
// const LMPressRelease = lazy( () => import( '@/components/templates/single/LMPressRelease' ) );
const LMSimplePage = lazy( () => import( '@/components/templates/single/LMSimplePage' ) );
// const LMTopic = lazy( () => import( '@/components/templates/single/LMTopic' ) );
// const LMVideo = lazy( () => import( '@/components/templates/single/LMVideo' ) );
// const LMWhitePaper = lazy( () => import( '@/components/templates/single/LMWhitePaper' ) );
// const Attachment = lazy( () => import( '@/components/templates/single/Attachment' ) );
// const DefaultSingle = lazy( () => import( '@/components/templates/single/DefaultSingle' ) );
const LandingPage = lazy( () => import( '@/components/templates/LandingPage' ) );
const Page404 = lazy( () => import( '@/components/templates/Page404' ) );

const templates: ComponentLoaderMap = {
    // 'about': LandingPage,
    // 'ad': LandingPage,
    'agents': LandingPage,
    // 'analyst-report': LMAnalystReport,
    // 'announcement': LMAnnouncement,
    'blog': LMBlog,
    'communities': LandingPage,
    // 'customer-story': LMCustomerStory,
    // 'default': DefaultSingle,
    // 'event': LMEvent,
    'form': LMForm,
    // 'glossary': LMGlossary,
    'landing-page': LandingPage,
    // 'legal': LMLegal,
    // 'location': LandingPage,
    // 'media-library': Attachment,
    // 'media-coverage': LMMediaCoverage,
    // 'podcast': LMPodcast,
    // 'press-release': LMPressRelease,
    'simple-page': LMSimplePage,
    // 'topic': LMTopic,
    // 'video': LMVideo,
    // 'white-paper': LMWhitePaper,
    '404': Page404,
};

export const PageSlugContext = createContext('');

const TemplateLoader: React.FC<TemplateLoaderProps> = ( { 
    iframe = false, 
    postType, 
    queryString = '', 
    slug, 
    layoutClassesFunction 
} ) => {
    const [ post, setPost ] = useState<Post | undefined>( undefined );
    const [ TemplateName, setTemplateName ] = useState<React.FC<TemplateProps>>();
    let finalPostType: string = postType;
    if ( finalPostType === 'media' ) {
        // rename
        finalPostType = 'media-library';
    }
    else if ( finalPostType === 'page' ) {
        // rename
        finalPostType = 'simple-page';
    }
    useEffect( () => {
        async function fetchData() {
                await lmGetPost( finalPostType, slug, queryString ).then( ( data: APIResult ) => {
                    if ( data.json ) {
                        setPost( data.json as Post );
                        const template: React.FC<TemplateProps> = templates[ finalPostType ] ? templates[ finalPostType ] : templates.default;
                        setTemplateName( template );
                    } 
                    else {
                        setPost( undefined );
                        setTemplateName( templates['404'] );
                    }
                } );
        }
        fetchData();
    }, [ slug ] );
    if ( TemplateName && post ) {
            return (
                <Suspense fallback={ <Loading /> }>
                    <PageSlugContext.Provider value={ slug }>
                        <TemplateName post={ post } iframe={ iframe ? iframe : false } layoutClasses={ layoutClassesFunction } />
                    </PageSlugContext.Provider>
                    <ScrollRestoration />
                </Suspense>
            );
    } else {
        return null;
    }
}
export default TemplateLoader;